import { ListColumn, ListColumnAlignment } from '@/interfaces'
import { computed } from 'vue'

const userCols = computed<ListColumn[]>(() => {
  return [
    {
      name: 'first_name',
      title: 'settings-publisher-users-name',
      width: 10,
      alignment: ListColumnAlignment.Left,
      sortable: true,
      position: 1,
      priority: 1,
      expand: true
    },
    {
      name: 'user_permissions',
      title: 'settings-publisher-users-permission',
      width: 20,
      alignment: ListColumnAlignment.Left,
      sortable: false,
      position: 2,
      priority: 2
    },
    {
      name: 'is_active',
      title: 'settings-publisher-users-activation',
      width: 15,
      alignment: ListColumnAlignment.Left,
      sortable: true,
      position: 3,
      priority: 3
    },
    {
      name: 'last_login',
      title: 'settings-publisher-users-last-active',
      width: 15,
      alignment: ListColumnAlignment.Left,
      sortable: true,
      position: 4,
      priority: 4
    },
    {
      name: 'created_at',
      title: 'create-date',
      width: 15,
      alignment: ListColumnAlignment.Left,
      sortable: true,
      position: 5,
      priority: 5
    },
    {
      name: 'actions',
      title: '',
      width: 15,
      alignment: ListColumnAlignment.Left,
      sortable: false,
      position: 6,
      priority: 0
    }
  ]
})

export default userCols
